import { z } from 'zod';
import { MessengerSchema } from './messenger-outcome';

export const MessengerSessionRequestedPayloadSchema = z.object({
  messenger: MessengerSchema,
  recipient: z.string().min(1),
});
export type MessengerSessionRequestedPayload = z.infer<typeof MessengerSessionRequestedPayloadSchema>;
